export default __webpack_public_path__ + "static/media/DeansList.01b14f94.pdf";